import SPACES from '@web-ui-kit/spaces'
import { styled } from 'styled-components'

export const MainContent = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${SPACES['2XL']};
  & > label {
    width: fit-content;
  }
`
